<template>
<!--    <div class="location-control text-body06-regular" v-if="bookViewFilter === false">
        <b-form-select v-model="internalValue" :options="locations" value-field="id" text-field="name" class="location-control-input text-body06-regular">
            <b-form-select-option :value=0 disabled >{{ label }}</b-form-select-option>
        </b-form-select>    
        <button class="location-control-icondiv" v-on:click="getMyLocation()">
            <img class="location-control-icon" src="@/assets/icon/v3/search.svg" alt="search">
        </button>
    </div>-->
  <div class="location-control-bislet text-body06-regular" >
      <b-form-group
          :label="$t('message.pickUpLocation')"
          lable-for="location-selection"
          class="no-gap-form-group"

      >

          <div id="location-selection" class="location-control" >

            <b-form-select v-model="internalValue" :options="locations" value-field="id" text-field="name" class="location-control-input text-body06-regular">
<!--              <b-form-select-option :value=0 disabled >{{ $t('message.pickUpLocation') }}</b-form-select-option>-->
            </b-form-select>
            <button class="location-control-icondiv" v-on:click="getMyLocation()">
              <img class="location-control-icon" src="@/assets/icon/v3/search.svg" alt="search">
            </button>

          </div>
      </b-form-group>
  </div>
</template>

<script>
export default {
    name: "LocationControlVersion2",
    props: ["value", "label", "locations","bookViewFilter"],
    data() {
        return {
        };
    },
    methods:{
        getMyLocation() {
                console.log('Set my location again')
                this.$emit("update-location", 0);
            },
    },
    computed: {
        
        internalValue: {
            get() {
              console.log(">>>>> this location value is ",this.value)
                return this.value;

            },
            set(newValue) {
                this.$emit("update-location", newValue);
            },
            
        },

    },

};
</script>

<style lang="scss" scoped>
      .no-gap-form-group ::v-deep{
        legend {
          padding-bottom: 0 !important;
          margin-bottom: 4px;
          color:#00168d;
          font-family: "Neue Helvetica",sans-serif;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1em;
        }
      }


    .location-control{
        display: flex;
        flex-direction: row;
        border: 1px solid var(--agile-custom4);
        border-radius: 10px;
        min-height: 33px;
      background-color: white;
    }
    .location-control-for-bislet{
        display: flex;
        flex-direction: row;

        border-radius: 10px;
        height: 100%;
    }
    .location-control-bislet{
        display: flex;
        flex-direction: column;


    }
    .location-selection-bislet-form{
      height:58px;
    }
    .location-control-input{
        border: none;
        border-radius: 10px;
        background-color: transparent;
        padding: 5px 5px 5px 15px;
        height: auto;
        text-align: left;

        color: var(--agile-purple);
        font-family: inherit;
        font-size: inherit;
        font-weight: inherit;

        background-image: none !important;
        
    }

    .location-control-input-bislet{
      border: none;
      border-radius: 10px;
      padding: 5px 5px 5px 15px;
      height: 58px;
      text-align: left;

      color: var(--agile-purple);
      /* Text/Text 14 */
      font-family: Helvetica Neue;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;

      background-image: none !important;
    }
    .location-control-icondiv{
        align-self: center;
        background-color: transparent;
        border: none;
        border-radius: 10px;
        padding-right: 16px;
    }
    .location-control-icon{
        width: 16px;
        height: 16px;

        color: var(--agile-custom4);
    }
</style>
